var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c(_vm.themeName,{key:_vm.uuidValue,tag:"component",attrs:{"data":_vm.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }